import * as actionTypes from './actionTypes'
import axiosdb from '../../axios-games'


export const setGamesPlayed = gamesPlayed => {
  return {
    type: actionTypes.SET_GAMES_PLAYED,
    gamesPlayed
  }
}

export const fetchGamesStart = () => {
  return {
    type: actionTypes.FETCH_GAMES_START
  }
}

export const fetchGamesSuccess = () => {
  return {
    type: actionTypes.FETCH_GAMES_SUCCESS
  }
}

export const fetchGamesInit = () => {
  return dispatch => {
    dispatch(fetchGamesStart())
    axiosdb.get('https://react-hangman-fe07a.firebaseio.com/games.json')
      .then(res => {
        const data = res.data
        const gamesPlayed = []
        for (let key in data) {
          gamesPlayed.push(data[key])
        }
        dispatch(fetchGamesSuccess())
        dispatch(setGamesPlayed(gamesPlayed))
      })
      .catch(err => console.log(err))
  }
}